export default {
  zh: {
    enjoy: "新用户享受 3 天免费试用",
    domesticServers: "国内线路",
    foreignServers: "国外线路",
    moreDomesticServers: "更多国内专线",
    moreForeignServers: "更多国外专线",
    vipAdvantage: "7天退款保障",
    numberOfDevices: "设备数：",
    device: "台",
    salePrice: "折后总价",
    month: "月",
    year: "一年",
    threeMonths: "季",
    sixMonths: "半年",
    noLimit: "无限流量",
    infoEncryption: "信息加密",
    subscribe: "连续订阅",
    topUp: "充值",
    CNY: "￥",
    USD: "$",
    off_text: "免费赠送 | 个月 | 个月",
    off_text_day: "免费赠送 | 天 | 天",
    guarantee: "7天退款保障",
    intro_1: "7天退款保障",
    intro_2: "台 | 台",
    intro_3: "在线",
    countDown: "倒计时",
    unlimitedTraffic: "无限流量 & 信息加密",
  },
  en: {
    enjoy: "Enjoy 3-Day Free Trial for New Users",
    domesticServers: "Domestic Servers",
    foreignServers: "Foreign Servers",
    moreDomesticServers: "More Domestic Servers",
    moreForeignServers: "More Foreign Servers",
    vipAdvantage: "7-Day Money-Back Guarantee",
    numberOfDevices: "Number of Devices: ",
    device: "Device",
    salePrice: "Sale Price",
    month: "Month",
    year: "Year",
    threeMonths: "3 Months",
    sixMonths: "6 Months",
    noLimit: "Unlimited Traffic",
    infoEncryption: "Information Encryption",
    subscribe: "Subscribe",
    topUp: "Get Now",
    CNY: "￥",
    USD: "$",
    off_text: "get extra | month free | months free",
    off_text_day: "get extra | day free | days free",
    guarantee: "7-day money-back guarantee",
    intro_1: "7-day refund guarantee",
    intro_2: "device | devices",
    intro_3: "online",
    countDown: "Expires in",
    unlimitedTraffic: "Unlimited Traffic & Information Encryption",
  },
};



// WEBPACK FOOTER //
// ./src/views/home/choosePackage/lang.js